import Axios from "./Axios";
import API_URL from "./URLS";

export const SING_UP = (data) => Axios.post(API_URL.SING_UP, data);
export const LOGIN = (data) => Axios.post(API_URL.LOGIN, data);
export const GET_EMAIL_OTP = (data) => Axios.post(API_URL.GET_EMAIL_OTP, data);
export const FORGET_PASSWORD = (data) =>
  Axios.post(API_URL.FORGET_PASSWORD, data);
export const VERIFY_OTP = (data) => Axios.post(API_URL.VERIFY_OTP, data);
export const RESET_PASSWORD = (data) =>
  Axios.post(API_URL.RESET_PASSWORD, data);

// dashbaord
export const DASHBOARD_REPORT = (data) =>
  Axios.post(API_URL.DASHBOARD_REPORT, data);

// profile
export const CHANGE_PASSWORD = (data) =>
  Axios.post(API_URL.CHANGE_PASSWORD, data);
export const GET_PROFILE_INFO = (data) =>
  Axios.get(API_URL.GET_PROFILE_INFO, data);
export const UPDATE_PROFILE = (data) =>
  Axios.post(API_URL.UPDATE_PROFILE, data);

// manage servies
export const GET_SERVICES = (data) => Axios.post(API_URL.GET_SERVICES, data);
export const SELECT_SERVICE = (data) =>
  Axios.post(API_URL.SELECT_SERVICE, data);

// manage drivers
export const GET_DRIVERS = (data) => Axios.post(API_URL.GET_DRIVERS, data);
export const DELETE_DRIVER = (data) => Axios.post(API_URL.DELETE_DRIVER, data);
export const ADD_DRIVER = (data) => Axios.post(API_URL.ADD_DRIVER, data);
export const EDIT_DRIVER = (data) => Axios.post(API_URL.EDIT_DRIVER, data);
export const GET_DRIVER_BY_ID = (data) =>
  Axios.get(API_URL.GET_DRIVER_BY_ID + data);
export const GET_DRIVER_VIEW = (data) =>
  Axios.post(API_URL.GET_DRIVER_VIEW + data);
export const EXPORT_DRIVER_CSV = () => Axios.get(API_URL.EXPORT_DRIVER_CSV);
export const IMPORT_DRIVERS_CSV = (data) =>
  Axios.post(API_URL.IMPORT_DRIVERS_CSV, data);
export const BLOCK_DRIVER = (data) => Axios.post(API_URL.BLOCK_DRIVER, data);

// booking requests

export const GET_BOOKING_REQUESTS = (data) =>
  Axios.post(API_URL.GET_BOOKING_REQUESTS, data);
export const GET_MY_BOOKINGS_REQUESTS = (data) =>
  Axios.post(API_URL.GET_MY_BOOKINGS_REQUESTS, data);

export const VIEW_BOOKING = (data) => Axios.get(API_URL.VIEW_BOOKING + data);
export const ACCEPT_BOOKING = (data) =>
  Axios.post(API_URL.ACCEPT_BOOKING, data);
export const REJECT_BOOKING = (data) =>
  Axios.post(API_URL.REJECT_BOOKING, data);
export const MAKE_OFFER = (data) => Axios.post(API_URL.MAKE_OFFER, data);

// transaction history

export const GET_TRANSACTION_HISTORY = (data) =>
  Axios.get(API_URL.GET_TRANSACTION_HISTORY);

// SETTING
// ==> payment method

export const ADD_PAYMENT_METHOD = (data) =>
  Axios.post(API_URL.ADD_PAYMENT_METHOD, data);

export const GET_PAYMENT_METHODS = (data) =>
  Axios.get(API_URL.GET_PAYMENT_METHODS, data);

// earning
export const GET_EARNING = (data) => Axios.post(API_URL.GET_EARNING, data);

// drivers payout

export const GET_DRIVERS_PAYOUT_LIST = (data) =>
  Axios.post(API_URL.GET_DRIVERS_PAYOUT_LIST, data);
export const DRIVER_PAYOUT = (data) => Axios.post(API_URL.DRIVER_PAYOUT, data);
export const DELETE_PAYMENT_METHODS = (data) =>
  Axios.post(API_URL.DELETE_PAYMENT_METHODS, data);

//
export const GET_WALLET_INFO = (data) =>
  Axios.post(API_URL.GET_WALLET_INFO, data);

// CONTENT

export const HELP_AND_SUPPORT = (data) =>
  Axios.post(API_URL.HELP_AND_SUPPORT, data);
export const TERMS_AND_CONDITION = (data) =>
  Axios.get(API_URL.TERMS_AND_CONDITION, data);
export const PRIVACY_POLICY = (data) => Axios.get(API_URL.PRIVACY_POLICY, data);
export const ABOUT_US = (data) => Axios.get(API_URL.ABOUT_US, data);
export const GET_FAQS = (data) => Axios.post(API_URL.GET_FAQS, data);

// file upload
export const FILE_UPLOAD = (data) => Axios.post(API_URL.FILE_UPLOAD, data);

// assign driver
export const GET_ASSIGN_DRIVER = (data) =>
  Axios.post(API_URL.GET_ASSIGN_DRIVER, data);
export const BOOKING_ASSIGN_DRIVER = (data) =>
  Axios.post(API_URL.BOOKING_ASSIGN_DRIVER, data);

export const CONNECT_BANK_DETAIL = (id) =>
  Axios.get(`${API_URL.CONNECT_WITH_STRIPE}?_id=${id}`);

// Guest Booking
export const BOOKING_LISTS = (data) => Axios.post(API_URL.BOOKING_LISTS, data);

export const BOOKING_DETAILS = (data) =>
  Axios.get(API_URL.BOOKING_DETAILS + data);

export const BOOKING_ACCEPT = (data) =>
  Axios.post(API_URL.BOOKING_ACCEPT, data);
export const BOOKING_REJECT = (data) =>
  Axios.post(API_URL.BOOKING_REJECT, data);

export const MYGUEST_BOOKING = (data) =>
  Axios.post(API_URL.MYGUEST_BOOKING, data);

export const GET_GUEST_ASSIGN_DRIVER = (data) =>
  Axios.post(API_URL.GET_GUEST_ASSIGN_DRIVER, data);

export const BOOKING_GUEST_ASSIGN_DRIVER = (data) =>
  Axios.post(API_URL.BOOKING_GUEST_ASSIGN_DRIVER, data);